import { Tooltip, TooltipFocusableTrigger } from "@zapier/design-system";
import { ReactNode } from "react";

type Props = {
  key?: string;
  content: string;
  ariaLabel?: string;
  placement?: "top" | "bottom" | "left" | "right";
  offset?: "small" | "medium" | "large";
  className?: string;
  onChange: (value: string) => void;
  children: ReactNode;
  name: string;
  value: string;
  isChecked?: boolean;
};

export function RadioButtonWithTooltip({
  key,
  content,
  ariaLabel,
  placement = "top",
  offset = "large",
  className,
  onChange,
  children,
  name,
  value,
  isChecked,
}: Props) {
  return (
    <Tooltip key={key} content={content} placement={placement} offset={offset}>
      <TooltipFocusableTrigger>
        <label className={className}>
          <input
            type="radio"
            name={name}
            value={value}
            checked={isChecked}
            aria-label={ariaLabel}
            className={className}
            onChange={(event) => onChange(event.target.value)}
          />
          {children}
        </label>
      </TooltipFocusableTrigger>
    </Tooltip>
  );
}
